module.exports = __webpack_public_path__ + "static/media/azon-thumb.d8c3a001.webp";